import { AxiosPromise } from 'axios';
import { instance } from '.';
import { URLS } from './index';
import { Logger } from 'fsts';
import { SearchParams } from '../model/searchParams';
import { DefaultBackendHelper } from '../utils/backendHelper';
import tblUpdateNews, {
  BereichListResult,
  CategoryListResult,
  AuthorListResult,
  TblUpdateNews,
  Value,
} from '../model/tblUpdateNews';
import ODataFilterBuilder from 'odata-filter-builder';
import { CONST } from '@/shared/utils/Constants';

const logger = new Logger('backend.TblUpdateSupplier');
export interface BackendTblUpdateNews {
  getTblUpdateNews: (searchParams: SearchParams, searchData?: any) => AxiosPromise<Value>;
  getAddNewsCompleted(payload: any): AxiosPromise<any>;
  getCanselNewsCompleted(payload: any): AxiosPromise<any>;
  getBereichList(payload: any): AxiosPromise<BereichListResult[]>;
  getCategoryList(payload: any): AxiosPromise<CategoryListResult[]>;
  getAuthorList(payload: any): AxiosPromise<AuthorListResult[]>;
  getCountTopNews(): AxiosPromise<number>;
}

export const defaultBackendTblUpdateNews: BackendTblUpdateNews = {
  getTblUpdateNews(searchParams: SearchParams, searchData?: any): AxiosPromise<Value> {
    var odfb = ODataFilterBuilder('and');
    // odfb.eq(CONST.OrganisationId, organisationId, false);
    let url = DefaultBackendHelper.makeUrl(
      `${URLS.tblUpdateNewsOdata}`,
      searchParams.dataOption,
      searchParams.orClauseFieldsIds,
      searchParams.filter,
      odfb
    );

    if (searchParams.filter?.length != 0) {
      url = url.replace('contains(tolower(nw_createdate),', "contains(tolower(cast(nw_createdate, 'Edm.String')),");
      url = url.replace(
        'contains(tolower(newsDoneTimeCompleted),',
        "contains(tolower(cast(newsDoneTimeCompleted, 'Edm.String')),"
      );
    }
    url = url.replace('orderby=nw_author_parsed', 'orderby=nw_author');
    return instance.put<Value>(url, searchData);
  },
  getBereichList(payload: any): AxiosPromise<BereichListResult[]> {
    return instance.post(`${URLS.tblUpdateNews}/GetBereichList`, payload);
  },
  getCategoryList(payload: any): AxiosPromise<CategoryListResult[]> {
    return instance.post(`${URLS.tblUpdateNews}/GetCategoryList`, payload);
  },
  getAuthorList(payload: any): AxiosPromise<AuthorListResult[]> {
    return instance.post(`${URLS.tblUpdateNews}/GetAuthorList`, payload);
  },
  getAddNewsCompleted(data: any): AxiosPromise<any> {
    return instance.put(`${URLS.tblUpdateNews}/AddNewsCompleted`, data);
  },
  getCanselNewsCompleted(data: any): AxiosPromise<any> {
    return instance.put(`${URLS.tblUpdateNews}/CanselNewsCompleted`, data);
  },
  getCountTopNews(): AxiosPromise<number> {
    return instance.put(`${URLS.tblUpdateNews}/GetCountTopNews`);
  },
};
